import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import '@/App.css';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import OnboardingPage from './pages/OnboardingPage';
import DashboardPage from './pages/DashboardPage';
import MatchesPage from './pages/MatchesPage';
import MessagesPage from './pages/MessagesPage';
import ProfilePage from './pages/ProfilePage';
import ReflectionsPage from './pages/ReflectionsPage';
import PricingPage from './pages/PricingPage';
import NewPricingPage from './pages/NewPricingPage';
import AdminPage from './pages/AdminPage';
import BrowseUsersPage from './pages/BrowseUsersPage';
import ViewUserProfilePage from './pages/ViewUserProfilePage';
import ConciergePage from './pages/ConciergePage';
import VideoDatePage from './pages/VideoDatePage';
import AppNav from './components/AppNav';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Authed = ({ user, children }) => (
  <div className="min-h-screen">
    <AppNav user={user} />
    {children}
  </div>
);

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const sessionToken = localStorage.getItem('session_token');
      if (sessionToken) {
        const response = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${sessionToken}` }
        });
        setUser(response.data);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      localStorage.removeItem('session_token');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-rose-50 via-white to-amber-50">
        <div className="animate-pulse text-2xl font-light text-rose-600">Loading...</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={user ? <Navigate to="/dashboard" /> : <LandingPage />} />
        <Route path="/auth" element={user ? <Navigate to="/dashboard" /> : <AuthPage setUser={setUser} />} />
        <Route path="/onboarding" element={user ? <OnboardingPage user={user} setUser={setUser} /> : <Navigate to="/auth" />} />
        <Route path="/dashboard" element={user ? <Authed user={user}><DashboardPage user={user} /></Authed> : <Navigate to="/auth" />} />
        <Route path="/matches" element={user ? <Authed user={user}><MatchesPage user={user} /></Authed> : <Navigate to="/auth" />} />
        <Route path="/messages/:matchId?" element={user ? <Authed user={user}><MessagesPage user={user} /></Authed> : <Navigate to="/auth" />} />
        <Route path="/profile" element={user ? <Authed user={user}><ProfilePage user={user} setUser={setUser} /></Authed> : <Navigate to="/auth" />} />
        <Route path="/profile/:userId" element={user ? <Authed user={user}><ViewUserProfilePage user={user} /></Authed> : <Navigate to="/auth" />} />
        <Route path="/reflections" element={user ? <Authed user={user}><ReflectionsPage user={user} /></Authed> : <Navigate to="/auth" />} />
        <Route path="/pricing" element={<NewPricingPage user={user} />} />
        <Route path="/browse" element={user ? <Authed user={user}><BrowseUsersPage user={user} /></Authed> : <Navigate to="/auth" />} />
        <Route path="/admin" element={user?.is_staff ? <Authed user={user}><AdminPage user={user} /></Authed> : <Navigate to="/dashboard" />} />
        <Route path="/concierge" element={user ? <Authed user={user}><ConciergePage user={user} /></Authed> : <Navigate to="/auth" />} />
        <Route path="/video/:dateId" element={user ? <VideoDatePage user={user} /> : <Navigate to="/auth" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;